import { Request, getParamsUrl } from '@/core'
import { laboratory } from '@/constants/urls'

export default {
  get: params => {
    const paramsFormatted = getParamsUrl(params)

    return Request.get(`${laboratory.list}${paramsFormatted}`)
  },
}
